import { CircularProgress } from '@mui/material';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { notificationStyles } from '~/shared/theme/theme';

export interface NotificationDetailsLabelsProps {
  label: string;
  value?: string;
  isLoading?: boolean;
  column?: boolean;
}

export function NotificationDetailsLabel({
  label,
  value = '-',
  isLoading = false,
  column = false,
}: NotificationDetailsLabelsProps) {
  return (
    <Box
      sx={{
        borderTop: '1px solid',
        borderColor: 'divider',
        pt: 4,
      }}
    >
      <Stack
        direction={column ? 'column' : 'row'}
        justifyContent="space-between"
        sx={{ mb: 4 }}
      >
        <Typography
          variant="body2"
          color={notificationStyles.darkText}
          sx={{ mb: column ? 4 : 0 }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          color={notificationStyles.lightText}
          fontWeight={400}
        >
          {isLoading ? <CircularProgress size={14} /> : value}
        </Typography>
      </Stack>
    </Box>
  );
}
